import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Utils } from '../../../../../../utils/utils';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'createexcellencefactor-popup',
    templateUrl: './createexcellencefactor-popup.component.html',
    styleUrls: ['./createexcellencefactor-popup.component.less'],
    standalone: false
})
export class CreateExcellenceFactorPopupComponent implements OnInit {

    form!: FormGroup
    accounts: any[] = []
    excellenceLevers: any[] = []
    allExcellenceLevers: ExcellenceLever[] = []
    groupFunctions: string[] = []
    selectedGroupFunction: string | undefined;
    archetypes: any[] = []
    archetypesLoaded: boolean = false
    archetypesFailed: boolean = false
    subscriptions: any[] = []

    constructor(
        public dialogRef: MatDialogRef<CreateExcellenceFactorPopupComponent>,
        private formBuilder: FormBuilder,
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private toastrService: ToastrService) { }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            name: [this.data?.Name, Validators.required],
            description: [this.data?.Description, Validators.required],
            excellenceLeverId: [this.data?.ExcellenceLeverId, Validators.required],
            excellenceFactorId: [this.data?.ExcellenceFactorId],
            archetypeIds: [this.data?.ArchetypeIds ?? []],
        });
        Utils.httpGetArchetypes(
            this.http
            , this.baseUrl
            , this
            , function (tthis: CreateExcellenceFactorPopupComponent, data: any[]) {
                tthis.archetypes = data;
                tthis.archetypesLoaded = true;
            },
            function (tthis: CreateExcellenceFactorPopupComponent) {
                tthis.archetypesFailed = true;
                tthis.toastrService.error('Archetypes could not be loaded. Please, contact with administrator');
            }
        )
        Utils.httpGetExcellenceLevers(
            this.http
            , this.baseUrl
            , this
            , function (tthis: CreateExcellenceFactorPopupComponent, data: ExcellenceLever[]) {
                tthis.allExcellenceLevers = data;
                tthis.excellenceLevers = data;
                tthis.groupFunctions = [...new Set<string>(data.map(l => l.GroupFunction).filter(gf => !!gf))].sort((a, b) => a.localeCompare(b));

                if (tthis.allExcellenceLevers.length > 0 && tthis.data){
                    tthis.selectedGroupFunction = tthis.allExcellenceLevers.find(x => x.ExcellenceLeverId == tthis.data?.ExcellenceLeverId)?.GroupFunction;
                }
            },
            null
        )
    }

    onSubmit() {
        // stop here if form is invalid
        if (this.form)
            if (this.form.invalid) {
                return;
            }

        Utils.httpUpsertExcellenceFactor(
            this.http
            , this.baseUrl
            , this.form.value
            , this
            , function (tthis: CreateExcellenceFactorPopupComponent, result: any) {
                tthis.dialogRef.close({ event: 'submit' });
                if (result) {
                    tthis.toastrService.success(`Excellence Factor was ${tthis.data ? 'updated' : 'created'} successfully!`);
                }
                else
                    tthis.toastrService.error(`Excellence factor could not be ${tthis.data ? 'updated' : 'created'}. Please, contact with administrator`);
            },
            null
        );
    }

    onGroupFunctionChange(gf: string) {
        this.selectedGroupFunction = gf;
        this.excellenceLevers = gf
            ? this.allExcellenceLevers.filter(l => l.GroupFunction === gf)
            : this.allExcellenceLevers;
        // Clear lever selection if it no longer belongs to the selected GF
        const currentLeverId = this.form.get('excellenceLeverId')?.value;
        if (currentLeverId && !this.excellenceLevers.some(l => l.ExcellenceLeverId === currentLeverId)) {
            this.form.get('excellenceLeverId')?.setValue(null);
        }
    }

    isArchetypeSelected(archetypeId: number): boolean {
        return (this.form.get('archetypeIds')?.value ?? []).includes(archetypeId);
    }

    onArchetypeToggle(archetypeId: number, isChecked: boolean) {
        const current: number[] = this.form.get('archetypeIds')?.value ?? [];
        const updated = isChecked
            ? [...current, archetypeId]
            : current.filter(id => id !== archetypeId);
        this.form.get('archetypeIds')?.setValue(updated);
    }

    backButtonHandler(event: any) {
        event.preventDefault();
        this.dialogRef.close();
    }
}
